import React from "react";
import { Typography } from "@mui/material";

/** Multi-line title text: natural word wrap, no tooltip, no line-clamp (customer quote/contract/invoice lists). */
export default function CustomerTitleWrapCell({ text }) {
  const s = text == null || text === "" ? "—" : String(text);
  return (
    <Typography
      component="div"
      sx={{
        fontSize: "0.9375rem",
        color: "text.primary",
        lineHeight: 1.45,
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxWidth: "100%",
      }}
    >
      {s}
    </Typography>
  );
}
